// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3cvXE","label":"styles_label__2qviP"};